import React from 'react';
import { Badge } from '../ui/Badge';
import { VoucherStatus } from '../../types/voucher.types';
interface VoucherStatusBadgeProps {
  status: VoucherStatus;
}
export function VoucherStatusBadge({
  status
}: VoucherStatusBadgeProps) {
  const variantMap: Record<VoucherStatus, 'success' | 'warning' | 'danger' | 'info' | 'default'> = {
    [VoucherStatus.DRAFT]: 'default',
    [VoucherStatus.PENDING]: 'warning',
    [VoucherStatus.COMPLETED]: 'info',
    [VoucherStatus.APPROVED]: 'success',
    [VoucherStatus.AUDITED]: 'success',
    [VoucherStatus.POSTED]: 'success',
    [VoucherStatus.REJECTED]: 'danger',
    [VoucherStatus.CANCELLED]: 'danger'
  };
  return <Badge variant={variantMap[status]} data-id="element-314">{status}</Badge>;
}